
export default function tohash(str: string) {
    let hash = 0, i, chr;
    if(typeof str !== 'string') return null;
    if (str.length === 0) return hash.toString();
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0;
    }
    return Math.abs(hash).toString();
}
